import { Typography } from "@mui/material"
import NextLink from "common/bit/NextLink"
import Image from "next/image"
import React from "react"
import styled from "styled-components"

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 16px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: column;
    padding: 0 16px;
  }
`
const StyledLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: center;
  }
`

const StyledTypography = styled(Typography)`
  font-size: 20px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledExtraInfo = styled(Typography)`
  font-size: 18px;
  font-weight: 300;

  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledNextLink = styled(NextLink)`
  color: ${({ theme }) => theme.colors.saphire};
  text-decoration: underline;
  direction: ltr;
  text-align: right;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
  }
`

export interface ContactLinkProps {
  url: string
  type: "email" | "phone" | "page"
  label: string
  icon: string
  linkLabel?: string
  extraInfo?: string
  blank?: boolean
}

const ContactLink: React.FC<ContactLinkProps> = ({
  url,
  type,
  label,
  icon,
  linkLabel,
  extraInfo,
  blank,
}) => {
  const generateLink = () => {
    if (type === "email") {
      return `mailto:${url}`
    }
    if (type === "phone") {
      return `tel:${url}`
    }
    return url
  }
  return (
    <StyledWrapper>
      <Image
        src={`/icons/contact/${icon}.svg`}
        alt={label}
        width="30"
        height="30"
        style={{
          maxWidth: "100%",
          height: "auto",
          objectFit: "contain"
        }} />
      <StyledLabelWrapper>
        <StyledTypography>{label}</StyledTypography>
        {extraInfo && <StyledExtraInfo>{extraInfo}</StyledExtraInfo>}
        <StyledNextLink href={generateLink()} openInNewTab={blank}>
          {linkLabel || url}
        </StyledNextLink>
      </StyledLabelWrapper>
    </StyledWrapper>
  );
}

export default ContactLink
